module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"AppNumber":{"button":{"minus":{"label":"Snížit množství"},"plus":{"label":"Zvýšit množství"}},"input":{"label":"Počet kusů"},"maxAmountReached":"O tento produkt je nyní velký zájem. Aby vyšlo i na ostatní, můžete zakoupit max. {limit}&nbsp;{unit}.","minAmountReached":"Musíte zakoupit minimálně {limit}&nbsp;{unit} tohoto produktu."}}}')
  delete Component.options._Ctor
}
